import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { ApiEndpoints } from "../../helper/ApiEndpoints";
import ApiRequest from "../../helper/ApiRequest";
import { BaseUrl } from "../../helper/BaseUrl";
import CustomImageUpload from "../../component/CustomImageUpload";
import DynamicCKEditor from "../../component/DynamicCkEditor";
import { toast } from "react-toastify";
import AdminHeader from "../../component/AdminHeader";

const dynamicEditEndpoint = ApiEndpoints.dynamic.dynamicEdit;
const dynamicUpdateEndpoint = ApiEndpoints.dynamic.dynamicUpdate;

export default function EditDynamic() {
  const navigate = useNavigate();
  const [loading, setLoading ] = useState(true);
  const { page_id } = useParams();
  const [previews, setPreviews] = useState({ banner_image: null,});
  const [postData, setPostData] = useState({ date: new Date(), title: "", slug: "", banner_image: null, alt_banner_image: "", description: "", description1:"", faqs: [] 
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await ApiRequest("GET", `${dynamicEditEndpoint}${page_id}`,);
        setPostData(response.page);
        setPreviews((prev) => ({
          ...prev,
          banner_image: BaseUrl + response.page.banner_image || prev.banner_image,
        }));
        if (response.page.alt_banner_image){setLoading(false)}

      } catch (error) {
        console.error("Error fetching page data:", error);
      }
    };

    fetchData();
  }, [page_id]);

  const handleChange = (e) => {
    const { name, value, files } = e.target;

    if (files) {
      const file = files[0];

      // Update the previews state
      setPreviews((prev) => ({
        ...prev,
        [name]: URL.createObjectURL(file),
      }));

      // Update the postData state
      setPostData((prev) => ({
        ...prev,
        [name]: file,
      }));
    } else {
      let updatedValue = value;
      if (name === "date") {
        updatedValue = new Date(value).toISOString();
      }
      setPostData((prev) => ({
        ...prev,
        [name]: updatedValue,
      }));
    }
  };

  const handleEditorChange = (key, data) => {
    setPostData((prevState) => ({
      ...prevState,
      [key]: data,
    }));
  };

  
  const handleSubmit = async (e) => {
    e.preventDefault();

    const mandatoryFields = [
      "title",
      "slug",
      "description",
      "description1",
      "banner_image",
      "alt_banner_image",
    ];

    for (let field of mandatoryFields) {
      if (!postData[field]) {
        toast.error(`${field.replace(/_/g, " ")} is mandatory`);
        return;
      }
    }

    // FAQ validation (optional)
    for (let i = 0; i < postData.faqs.length; i++) {
      const { question, answer } = postData.faqs[i];

      // If one is filled, the other becomes mandatory
      if ((question && !answer) || (!question && answer)) {
        toast.error(`Please fill both Question and Answer for FAQ`);
        return;
      }
    }

    // Remove empty FAQs
    const cleanedFaqs = postData.faqs.filter(
      (faq) => faq.question && faq.answer
    );

    // Build FormData
    const formData = new FormData();

    Object.entries(postData).forEach(([key, value]) => {
      if (key === "faqs") {
        // ✅ ALWAYS send faqs (even empty array)
        formData.append("faqs", JSON.stringify(cleanedFaqs));
      } else {
        formData.append(key, value);
      }
    });


    try {
      const response = await ApiRequest(
        "POST",
        dynamicUpdateEndpoint + page_id,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );

      toast.success(response.message);
      navigate("/dynamic");
    } catch (error) {
      console.error("Error submitting form:", error);
      toast.error("Something went wrong. Please try again.");
    }
  };


  // =========FAQS Functionality

    // 🔹 handle change for question/answer
    const handleFaqChange = (index, field, value) => {
      setPostData((prev) => {
        const updatedFaqs = [...prev.faqs];
        updatedFaqs[index][field] = value;
        return { ...prev, faqs: updatedFaqs };
      });
    };

    // 🔹 add new FAQ
    const addFaq = () => {
      setPostData((prev) => ({
        ...prev,
        faqs: [...prev.faqs, { question: "", answer: "" }],
      }));
    };

    // 🔹 remove FAQ
    const removeFaq = (index) => {
      setPostData((prev) => ({
        ...prev,
        faqs: prev.faqs.filter((_, i) => i !== index),
      }));
    };


    const pagename = {
      name: 'Dynamic Page',
      user: 'Admin',
      innerpage: 'Dynamic Page / Pages / Edit page'
    }

  if(loading){return null;}
  

  return (
    <>
      <AdminHeader pagename={pagename} />

      <div className="add-content-page">
        <form id="dynamicEdit" onSubmit={handleSubmit}>

          <div className="add-content-wrap">
            <div className="row">

              <div className="col-lg-12">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>title<small>*</small></label>
                  </div>
                  <input value={postData?.title} onChange={handleChange} name="title" type="text" className="form-control" placeholder="Enter Title" />
                </div>
              </div>
 
              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>slug<small>*</small></label>
                  </div>
                  <input value={postData?.slug} onChange={handleChange} name="slug" type="text" className="form-control" placeholder="Enter Slug" />
                </div>
              </div>

              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Date<small>*</small></label>
                  </div>
                  <input value={postData.date ? new Date(postData.date).toISOString().split("T")[0] : ""} onChange={handleChange} name="date" type="date" className="form-control" placeholder="" />
                </div>
              </div>
            </div>
          </div>

          <div className="add-content-wrap">
            <div className="row">
              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Top Description<small>*</small></label>
                  </div>
                  <DynamicCKEditor data={postData.description} onChange={(event) => handleEditorChange("description", event?.editor?.getData())} />
                </div>
              </div>

              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Description 1<small>*</small></label>
                  </div>
                  <DynamicCKEditor data={postData.description1} onChange={(event) => handleEditorChange("description1", event?.editor?.getData())} />
                </div>
              </div>
            </div>
          </div>

          <div className="add-content-wrap">
            <div className="row">
              <div className="col-lg-6">
                <div className="add-page-inputs input-add-image">
                  <div className="label-wrap-add">
                    <label>Image (1100 × 550)<small>*</small></label>
                  </div>
                  <CustomImageUpload name="banner_image"
                    // maxSize={100 * 1024} // 320KB
                    acceptedFormats={[".webp"]}
                    onImageChange={handleChange}
                    imagePreview={previews.banner_image}
                  />
                </div>
              </div>

              <div className="col-lg-6">
                 <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Image Alt Tag<small>*</small></label>
                  </div>
                  <input value={postData.alt_banner_image || ""} onChange={handleChange} name="alt_banner_image" type="text" className="form-control" placeholder="alt banner" />
                </div>
              </div>
            </div>
          </div>

          <div className="add-content-wrap">
            <h5>Faq Section</h5>
            <div className="row">
              {postData.faqs.length > 0 &&
                postData.faqs.map((faq, index) => (
                  <div key={index} className="col-lg-6" style={{ position: "relative" }}>
                    <div className="add-page-inputs">
                      <div className="label-wrap-add">
                        <label>Question</label>
                      </div>
                      <input className="form-control" type="text" placeholder={`Question ${index + 1}`} value={faq.question} onChange={(e) => handleFaqChange(index, "question", e.target.value)}/>
                    </div>

                    <div className="add-page-inputs">
                      <div className="label-wrap-add">
                        <label>Answer</label>
                      </div>
                      <input className="form-control" placeholder={`Answer ${index + 1}`} value={faq.answer} onChange={(e) => handleFaqChange(index, "answer", e.target.value)}/>
                    </div>

                    <button onClick={() => removeFaq(index)} type="button" className="delete-faqfield">X</button>
                  </div>
                ))
              }

              <div className="col-lg-12 add-page-inputs"> 
                <button type="button" className="addmore-images-client w-100" onClick={addFaq}>Add FAQ +</button> 
              </div>

            </div>
          </div>
        </form>
        <button type="submit" form="dynamicEdit" className="default-btn">publish <span></span></button>
      </div>
    </>
  );
}

